import { useEffect, useState } from "react"
import { FaMinus, FaPlus } from "react-icons/fa"
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getDatabase, increment, onValue, ref, set } from "firebase/database"
import { StandardCounter } from "../../types/CounterTypes"
import { cn } from "../../utils/cn"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC-zsF1AdGcb5tg9Vo6bB1usgiK3VoiQ5c",
  authDomain: "kfk-environment.firebaseapp.com",
  databaseURL:
    "https://kfk-environment-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "kfk-environment",
  storageBucket: "kfk-environment.appspot.com",
  messagingSenderId: "209981891412",
  appId: "1:209981891412:web:dd288e5984c387af509ec1",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const db = getDatabase(app)

interface StandardProps {
  id: string
  object: typeof StandardCounter
}

export default function Standard({ id, object }: StandardProps) {
  const [counterObject, setCounterObject] = useState(object)

  const updateCounter = async ({
    delta_fliers,
    delta_ths,
  }: {
    delta_fliers: number
    delta_ths: number
  }) => {
    const counterRef = ref(db, `counters/${id}`)
    await set(counterRef, {
      type: "standard",
      fliers: increment(delta_fliers),
      ths: increment(delta_ths),
    })
  }

  useEffect(() => {
    onValue(ref(db, `counters/${id}`), (snapshot) => {
      const data = snapshot.val()
      console.log(data)

      setCounterObject(data)
    })
  }, [])

  return (
    <div className="bg-slate-900 w-full h-fit min-h-screen flex flex-col items-center justify-center">
      <div className="max-w-xs w-full flex flex-col gap-6 my-6">
        {counterObject ? (
          <>
            <div>
              <div className={`font-medium text-xl text-white `}>
                Flygare/Doktorand
              </div>
              <div className="font-medium text-center text-6xl text-white">
                {counterObject.fliers}
              </div>
              <div className="flex justify-between w-full gap-16 mt-3">
                <button
                  className="bg-red-500 text-white w-full rounded-lg h-16 flex justify-center items-center"
                  onClick={async () => {
                    await updateCounter({
                      delta_fliers: -1,
                      delta_ths: 0,
                    })
                  }}
                >
                  <FaMinus />
                </button>
                <button
                  className="bg-green-500 text-white w-full rounded-lg h-16 flex justify-center items-center"
                  onClick={async () => {
                    await updateCounter({
                      delta_fliers: 1,
                      delta_ths: 0,
                    })
                  }}
                >
                  <FaPlus />
                </button>
              </div>
            </div>
            <div>
              <div className="font-medium text-xl text-white">Externa</div>
              <div className="font-medium text-center text-6xl text-white">
                {counterObject.ths}
              </div>
              <div className="flex justify-between w-full gap-16 mt-3">
                <button
                  className="bg-red-500 text-white w-full rounded-lg h-16 flex justify-center items-center"
                  onClick={async () => {
                    await updateCounter({
                      delta_fliers: 0,
                      delta_ths: -1,
                    })
                  }}
                >
                  <FaMinus />
                </button>
                <button
                  className="bg-green-500 text-white w-full rounded-lg h-16 flex justify-center items-center"
                  onClick={async () => {
                    await updateCounter({
                      delta_fliers: 0,
                      delta_ths: 1,
                    })
                  }}
                >
                  <FaPlus />
                </button>
              </div>
            </div>
            <div>
              <div className="font-medium text-xl text-white">Totalt</div>
              <div
                className={cn(
                  "font-medium text-center text-6xl text-white",
                  counterObject.fliers + counterObject.ths > 120
                    ? "text-yellow-300"
                    : "",
                  counterObject.fliers + counterObject.ths > 139
                    ? "text-red-500"
                    : ""
                )}
              >
                {counterObject.fliers + counterObject.ths}
              </div>
            </div>
          </>
        ) : (
          <div>Hittade inte countern...</div>
        )}
      </div>
    </div>
  )
}
